import React from "react";
import { Medal, Info, TrendingUp } from "lucide-react";

const tierGradient = (tier) => {
  if (tier === "Gold") return "from-amber-500 to-yellow-600";
  if (tier === "Silver") return "from-slate-400 to-slate-600";
  return "from-orange-500 to-amber-700";
};

const tierRing = (tier) => {
  if (tier === "Gold") return "ring-amber-500/40";
  if (tier === "Silver") return "ring-slate-400/40";
  return "ring-orange-500/40";
};

const KarmaHero = ({ karma, onHow }) => {
  if (!karma) return null;
  const { balance, tier, next_tier, next_tier_at, progress_percent } = karma;
  const remaining = next_tier_at != null ? Math.max(0, next_tier_at - balance) : 0;
  return (
    <div className={`relative overflow-hidden rounded-2xl bg-gradient-to-br ${tierGradient(tier)} text-white p-6 sm:p-8 shadow-lg ring-1 ${tierRing(tier)}`} data-testid="karma-hero">
      <div className="absolute -top-8 -right-8 opacity-15 text-[180px] leading-none select-none pointer-events-none">★</div>
      <div className="flex flex-wrap items-start justify-between gap-4 relative">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] font-semibold opacity-80">Karma balance</div>
          <div className="mt-2 font-display text-5xl sm:text-6xl font-bold tracking-tight" data-testid="karma-balance">{balance}</div>
          <div className="mt-2 inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold" data-testid="karma-tier">
            <Medal className="w-3.5 h-3.5" /> {tier} tier
          </div>
        </div>
        <button
          type="button"
          onClick={onHow}
          className="inline-flex items-center gap-1.5 text-xs font-semibold bg-white/15 hover:bg-white/25 transition-colors px-3 py-1.5 rounded-full"
          data-testid="how-to-earn-btn"
        >
          <Info className="w-3.5 h-3.5" /> How to earn Karma
        </button>
      </div>
      {next_tier ? (
        <div className="mt-6 relative">
          <div className="flex items-center justify-between gap-2 text-xs font-medium opacity-90">
            <span className="hidden sm:inline">{tier}</span>
            <span className="truncate">{remaining} more Karma to {next_tier}</span>
            <span className="hidden sm:inline">{next_tier}</span>
          </div>
          <div className="mt-2 h-2 rounded-full bg-white/20 overflow-hidden">
            <div className="h-full bg-white rounded-full transition-all" style={{ width: `${progress_percent}%` }} data-testid="karma-progress" />
          </div>
        </div>
      ) : (
        <div className="mt-6 text-sm font-semibold opacity-90 inline-flex items-center gap-1.5"><TrendingUp className="w-4 h-4" /> Top tier reached.</div>
      )}
    </div>
  );
};

export default KarmaHero;
